var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptopAndEmail12472(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 83.914 69.449 V 17.907 c 0 -1.263 -1.024 -2.288 -2.288 -2.288 H 8.373 c -1.263 0 -2.288 1.024 -2.288 2.288 v 51.541 H 83.914 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(29,84,189)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.5 59.449 v -36.31 c 0 -1.162 -0.942 -2.104 -2.104 -2.104 H 13.604 c -1.162 0 -2.104 0.942 -2.104 2.104 v 36.31 H 78.5 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(168,207,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.997 64.449 v 3.857 H 33.003 v -3.857 H 1 v 3.234 c 0 3.699 2.999 6.698 6.698 6.698 h 74.604 c 3.699 0 6.698 -2.999 6.698 -6.698 v -3.234 H 56.997 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(173,238,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82.302 75.38 H 7.698 C 3.454 75.38 0 71.927 0 67.682 v -3.233 c 0 -0.553 0.448 -1 1 -1 h 32.003 c 0.552 0 1 0.447 1 1 v 2.857 h 21.994 v -2.857 c 0 -0.553 0.447 -1 1 -1 H 89 c 0.553 0 1 0.447 1 1 v 3.233 C 90 71.927 86.547 75.38 82.302 75.38 z M 2 65.448 v 2.233 c 0 3.142 2.556 5.698 5.698 5.698 h 74.604 c 3.142 0 5.698 -2.557 5.698 -5.698 v -2.233 H 57.997 v 2.857 c 0 0.553 -0.447 1 -1 1 H 33.003 c -0.552 0 -1 -0.447 -1 -1 v -2.857 H 2 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(8,28,66)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.914 65.448 c -0.553 0 -1 -0.447 -1 -1 V 17.907 c 0 -0.71 -0.577 -1.288 -1.287 -1.288 H 8.374 c -0.71 0 -1.288 0.578 -1.288 1.288 v 46.541 c 0 0.553 -0.448 1 -1 1 s -1 -0.447 -1 -1 V 17.907 c 0 -1.813 1.475 -3.288 3.288 -3.288 h 73.253 c 1.813 0 3.287 1.475 3.287 3.288 v 46.541 C 84.914 65.001 84.467 65.448 83.914 65.448 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(8,28,66)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.5 60.448 h -67 c -0.552 0 -1 -0.447 -1 -1 v -36.31 c 0 -1.712 1.393 -3.104 3.104 -3.104 h 62.791 c 1.712 0 3.104 1.393 3.104 3.104 v 36.31 C 79.5 60.001 79.053 60.448 78.5 60.448 z M 12.5 58.448 h 65 v -35.31 c 0 -0.609 -0.495 -1.104 -1.104 -1.104 H 13.604 c -0.609 0 -1.104 0.496 -1.104 1.104 V 58.448 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(8,28,66)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.56,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 32.89,
    height: 23,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(254,254,254)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 61.444 52.5 H 28.556 c -0.552 0 -1 -0.447 -1 -1 v -23 c 0 -0.552 0.448 -1 1 -1 h 32.888 c 0.553 0 1 0.448 1 1 v 23 C 62.444 52.053 61.997 52.5 61.444 52.5 z M 29.556 50.5 h 30.888 v -21 H 29.556 V 50.5 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(8,28,66)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 44.381 c -0.24 0 -0.48 -0.086 -0.671 -0.258 L 27.885 29.242 c -0.41 -0.371 -0.441 -1.003 -0.071 -1.413 c 0.371 -0.41 1.002 -0.441 1.413 -0.071 L 45 42.032 l 15.773 -14.274 c 0.409 -0.369 1.041 -0.339 1.412 0.071 s 0.339 1.042 -0.07 1.413 L 45.671 44.123 C 45.48 44.294 45.24 44.381 45 44.381 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(8,28,66)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.557 52.5 c -0.273 0 -0.544 -0.111 -0.742 -0.329 c -0.37 -0.409 -0.339 -1.042 0.071 -1.412 l 12.708 -11.5 c 0.41 -0.37 1.042 -0.338 1.413 0.071 c 0.37 0.409 0.339 1.042 -0.071 1.413 l -12.708 11.5 C 29.036 52.415 28.796 52.5 28.557 52.5 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(8,28,66)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 61.444 52.5 c -0.239 0 -0.479 -0.085 -0.671 -0.259 l -12.708 -11.5 c -0.409 -0.371 -0.441 -1.003 -0.07 -1.413 c 0.37 -0.41 1.003 -0.441 1.412 -0.071 l 12.708 11.5 c 0.409 0.37 0.441 1.003 0.07 1.412 C 61.988 52.389 61.717 52.5 61.444 52.5 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(8,28,66)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopAndEmail12472);
export default __webpack_public_path__ + "static/media/laptop-and-email-12472.9a7c1925585d1df359c11cd0f5694f6c.svg";
export { ForwardRef as ReactComponent };